//External
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Select, { components } from "react-select";
import { getbrandVehicleList } from "store/actions";

/*******************
@Purpose : Used for make select
@Parameter : {brandList,currentLocationId,setSelectedMake,selectedMake,setSelectedModal,setVehicalDetailData}
@Author : INIC
******************/
function MakesSelect({
  brandList,
  currentLocationId,
  setSelectedMake,
  selectedMake,
  setSelectedModal,
  setVehicalDetailData,
  setNoSlotError,
  setNoVehicleError, setDateObj, setStartDate,
  setEndDate,
  setStartTimeDefaultValue,
  setEndTimeDefaultValue,
}) {
  const dispatch = useDispatch();
  const { ValueContainer, Placeholder } = components;
  const [make, setMake] = useState([]);
  const [inputClicked, setInputClicked] = useState(false);

  /*******************
@Purpose : React Hook Used for brand list
@Parameter : {}
@Author : INIC
******************/
  useEffect(() => {
    let makes = [];
    brandList &&
      brandList.map((brand) => {
        makes.push({
          value: brand.id,
          label: brand.title,
          image: brand?.image?.jpeg_w180,
        });
      });
    setMake(makes);
  }, [brandList]);

  /*******************
@Purpose : React Hook Used for dispatch get brand vehicle list
@Parameter : {}
@Author : INIC
******************/
  useEffect(() => {
    if (selectedMake) {
      setSelectedModal("");
      setVehicalDetailData("");
      dispatch(getbrandVehicleList(selectedMake.value, currentLocationId));
    }
  }, [selectedMake]);

  /*******************
@Purpose :  Used for Custom Value Container
@Parameter : {children, ...props}
@Author : INIC
******************/
  const CustomValueContainer = ({ children, ...props }) => {
    /*******************
   @purpose : Render HTML/ React Components
   @Author : INIC
   ******************/
    return (
      <ValueContainer {...props}>
        <Placeholder {...props} isFocused={props.isFocused}>
          {props.selectProps.placeholder}
        </Placeholder>
        {React.Children.map(children, (child) =>
          child && child.type !== Placeholder ? child : null
        )}
      </ValueContainer>
    );
  };

  /*******************
@Purpose :  Used for formate option label
@Parameter : {image, label }
@Author : INIC
******************/
  const formatOptionLabel = ({ image, label }) => (
    <div className="image-select__image-option">
      <span className="selected-img">
        <img src={image} width={"56px"} height="auto" alt={label} />
      </span>
      <span>{label}</span>
    </div>
  );

  /*******************
   @purpose : Render HTML/ React Components
   @Author : INIC
   ******************/
  return (
    <Select
      instanceId="makesId"
      className={`select-float mt-0 select-big-container  carmake-select ${inputClicked ? "makeModalFocus" : ""
        }`}
      classNamePrefix="select_float"
      menuPlacement="bottom"
      placeholder="Make*"
      isClearable={false}
      isSearchable={false}
      // closeMenuOnSelect={false}
      options={make}
      formatOptionLabel={formatOptionLabel}
      onChange={(e) => {
        setSelectedMake(e);
        setInputClicked(false);
        setNoSlotError("")
        setNoVehicleError("")
        setStartTimeDefaultValue(null)
        setEndTimeDefaultValue(null)
        setDateObj([
          {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
          },
        ]);
        setStartDate("");
        setEndDate("");
      }}
      onFocus={() => setInputClicked(true)}
      onMenuOpen={() => setInputClicked(true)}
      onMenuClose={() => {
        setInputClicked(false);
      }}
      // components={{ ValueContainer: CustomValueContainer }}
      styles={{
        container: (provided, state) => ({
          ...provided,
          marginTop: 50,
        }),
        valueContainer: (provided, state) => ({
          ...provided,
          overflow: "visible",
        }),
        placeholder: (provided, state) => ({
          ...provided,
          position: "absolute",
          top: state.hasValue || state.selectProps.inputValue,
          transition: "top 0.2s, font-size 0.2s",
          fontSize: (state.hasValue || state.selectProps.inputValue) && 13,
        }),
      }}
    />
  );
}
export default MakesSelect;
